import React from 'react'

const IconAskIA = ({ fill = '#000' }) => {
  return (
    <svg width='68' height='46' viewBox='0 0 68 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_18229_34087)'>
        <path
          d='M38.8932 5.63636H20.1496C14.3647 5.63636 9.67521 10.2763 9.67521 16C9.67521 21.7237 14.3647 26.3636 20.1496 26.3636H38.8932H43.433V30H38.8932C31.0786 30 28.4188 36 25.8462 36C23.2735 36 27.9642 30 20.1496 30C12.335 30 6 23.732 6 16C6 8.26801 12.335 2 20.1496 2H38.8932V5.63636Z'
          fill={fill}
        />
        <path d='M42.9017 2V5.63636H38.7617V2H42.9017Z' fill='#EB5323' />
        <path d='M47.4487 30V26.3636H43.3087V30H47.4487Z' fill='#EB5323' />
        <path
          d='M11.2266 16.0008C11.2266 11.0314 15.2551 7.00293 20.2244 7.00293H43.0556V24.9987H20.2244C15.255 24.9987 11.2266 20.9702 11.2266 16.0008Z'
          fill={fill}
        />
        <path
          d='M43.0547 7.00293H53.0027C57.9721 7.00293 62.0005 11.0314 62.0005 16.0008C62.0005 20.9702 57.9721 24.9987 53.0027 24.9987H43.0547V7.00293Z'
          fill='#EB5323'
        />
        <path
          d='M37.5294 20.0157L34.4909 16.5398V20.0157H33.2031V12.248H34.4909V15.791L37.5407 12.248H39.1561L35.7447 16.1375L39.2125 20.0157H37.5294Z'
          fill='white'
        />
        <path
          d='M28.9741 20.0939C28.447 20.0939 27.9725 20.0045 27.5508 19.8257C27.1291 19.6394 26.7978 19.3786 26.5568 19.0433C26.3158 18.7081 26.1953 18.3169 26.1953 17.8698H27.5734C27.6035 18.2051 27.7353 18.4808 27.9688 18.6969C28.2097 18.913 28.5449 19.021 28.9741 19.021C29.4184 19.021 29.7648 18.9167 30.0133 18.7081C30.2618 18.492 30.3861 18.2163 30.3861 17.881C30.3861 17.6202 30.307 17.4079 30.1489 17.2439C29.9983 17.08 29.8062 16.9533 29.5728 16.8639C29.3469 16.7745 29.0306 16.6777 28.6239 16.5733C28.1118 16.4392 27.6939 16.3051 27.3701 16.171C27.0538 16.0294 26.7827 15.8133 26.5568 15.5228C26.3309 15.2322 26.2179 14.8447 26.2179 14.3604C26.2179 13.9133 26.3309 13.5222 26.5568 13.1869C26.7827 12.8516 27.099 12.5945 27.5056 12.4157C27.9123 12.2369 28.3829 12.1475 28.9176 12.1475C29.6782 12.1475 30.2995 12.3375 30.7814 12.7175C31.2709 13.09 31.542 13.6041 31.5947 14.2598H30.1715C30.1489 13.9767 30.0133 13.7345 29.7648 13.5333C29.5163 13.3322 29.1887 13.2316 28.7821 13.2316C28.4131 13.2316 28.1118 13.3247 27.8784 13.511C27.6449 13.6973 27.5282 13.9655 27.5282 14.3157C27.5282 14.5541 27.5998 14.7516 27.7428 14.9081C27.8935 15.0571 28.0817 15.1763 28.3076 15.2657C28.5336 15.3551 28.8423 15.452 29.2339 15.5563C29.7535 15.6979 30.1752 15.8394 30.499 15.981C30.8304 16.1226 31.109 16.3424 31.3349 16.6404C31.5684 16.931 31.6851 17.3222 31.6851 17.8139C31.6851 18.2088 31.5759 18.5814 31.3575 18.9316C31.1467 19.2818 30.8342 19.5649 30.42 19.781C30.0133 19.9896 29.5314 20.0939 28.9741 20.0939Z'
          fill='white'
        />
        <path
          d='M23.243 18.4281H19.9559L19.3911 20.0152H18.0469L20.8595 12.2363H22.3506L25.1633 20.0152H23.8078L23.243 18.4281ZM22.8815 17.3887L21.6051 13.7787L20.3173 17.3887H22.8815Z'
          fill='white'
        />
        <path
          d='M54.0984 18.4437H50.8113L50.2466 20.0308H48.9023L51.715 12.252H53.2061L56.0187 20.0308H54.6632L54.0984 18.4437ZM53.737 17.4043L52.4605 13.7943L51.1728 17.4043H53.737Z'
          fill='white'
        />
        <path d='M47.6744 12.2627V20.0303H46.3867V12.2627H47.6744Z' fill='white' />
      </g>
      <defs>
        <filter
          id='filter0_d_18229_34087'
          x='0'
          y='0'
          width='68'
          height='46'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='3' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_18229_34087' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_18229_34087'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default IconAskIA
